/**
 * 完了画面の DL バナー: 表示順が上のキャリコネ行が①（媒体取得）待ちのあいだ、最大 HOLD_MS だけバナーを出さずに待つ。
 * 先に他社バナーを出すと、①が対象で返っても差し替えない（他社の文面への同意を持ち越さない）ため、
 * キャリコネが一度も出なくなる。待っても決まらなければ AUTO_RT を再 emit して次の行（今までの動き）へ進ませる。
 * 待ち時間は出力画面に入ってから最初に「待ち」を判定した時点から数える（出力画面を離れると FORCE_HIDE で戻す）。
 */
import { useTimeoutFn } from '@vueuse/core'
import { emitter, AUTO_RT, FORCE_HIDE_RT_DIALOGS } from '@/plugins/emitter'
import { getCcAutoRtArgs } from '@/composables/useCareerconnectionAutoRtArgs'

export const CC_BANNER_HOLD_MS = 3000

let holdStartedAt: number | null = null
// この出力画面でバナーを出したか（出力画面に入り直したら前回のバナーは数えない）
let shownThisSession = false
let subscribed = false

const holdTimeout = useTimeoutFn(
  () => {
    // 待ちの終わり: 選定をやり直させる（今度は待たずに次の行へ進む）
    const args = getCcAutoRtArgs()
    if (args) emitter.emit(AUTO_RT, args)
  },
  CC_BANNER_HOLD_MS,
  { immediate: false }
)

export function resetCcBannerHold(): void {
  holdStartedAt = null
  shownThisSession = false
  holdTimeout.stop()
}

/** この出力画面でバナーを出した印（差し替え防止と待ちの判定に使う） */
export function markCcBannerSessionShown(): void {
  subscribeOnce()
  shownThisSession = true
}

export function isCcBannerShownThisSession(): boolean {
  return shownThisSession
}

function subscribeOnce() {
  if (subscribed) return
  subscribed = true
  emitter.on(FORCE_HIDE_RT_DIALOGS, resetCcBannerHold)
}

/** いま待つべきか。初回の呼び出しで待ちを始め、HOLD_MS 経過後は false */
export function shouldHoldForPendingCc(): boolean {
  subscribeOnce()
  const now = Date.now()
  if (holdStartedAt == null) {
    holdStartedAt = now
    holdTimeout.start()
  }
  return now - holdStartedAt < CC_BANNER_HOLD_MS
}

/** この出力画面で他社のバナーを出したあとに、キャリコネへ差し替えようとしているか */
export function keepShownOverCc(
  current: { clientId?: unknown; ccAllianceKey?: unknown },
  selected: { ccAllianceKey?: unknown }
): boolean {
  return (
    shownThisSession &&
    !!current.clientId &&
    !current.ccAllianceKey &&
    !!selected.ccAllianceKey
  )
}
